<template>
  <el-container style="width:100%; height:100vh; display: flex; flex-direction: column; background-color: ghostwhite">
    <div style="padding:15px 0px; box-sizing: border-box;" class="row">
      <el-icon style="font-size: 22px;margin-right:-35px" @click="showUploadDialog"><upload-filled /></el-icon>
      <input class="input-box" v-model="query" placeholder="输入您想查询的内容"/>
      <el-icon style="margin-left:-40px; font-size: 22px"><Search /></el-icon>
    </div>
    <el-main style="flex-grow: 1.0" class="row-center">
      <div style="width:40%; margin-left:30%">

      </div>
    </el-main>
    <el-footer class="row" style="color: gray; font-size:12px">已经到最底部</el-footer>


    <el-dialog v-model="dialogVisible" title="图片上传" width="60%" align-center style="border-radius: 15px;">
      <el-upload v-model:file-list="fileList" action="/files/upload" list-type="picture-card" accept=".jpg,.jpeg,.png,.gif"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove">
        <el-icon><Plus /></el-icon>
      </el-upload>
      <div style="margin-top: 20px; width: 100%;margin-bottom: 10px;">
      <input placeholder="图片描述" class="desc-box"/>
      </div>
    </el-dialog>


  </el-container>
</template>
<script setup>
import {ref} from "vue";
// import { UploadFilled } from '@element-plus/icons-vue'
const query = ref("");
const dialogVisible = ref(false);
// const dialogImageUrl = ref('');
const showUploadDialog = () =>{
  dialogVisible.value = true;
}



const fileList = ref([
  {
    name: 'food0.jpeg',
    url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
  },
  {
    name: 'food1.jpeg',
    url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
  },
  {
    name: 'food2.jpeg',
    url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
  },
  {
    name: 'food3.jpeg',
    url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
  }
])




const handleRemove = (uploadFile, uploadFiles) => {
  console.log(uploadFile, uploadFiles);
  console.log(fileList.value);
}

const handlePictureCardPreview = (uploadFile) => {
  console.log(uploadFile);
}

</script>
<style scoped>

.input-box{
  font-size:16px;
  padding: 12px;
  outline: none;
  border: none;
  width:40%;
  height:60px;
  border: 1px solid ghostwhite;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  text-indent: 30px;
  border-radius:20px;
}

.desc-box{
  font-size:14px;
  padding: 6px;
  outline: none;
  border: none;
  width:100%;
  margin-left: 0%;
  height:50px;
  border: 1px solid ghostwhite;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  text-indent: 10px;
  border-radius:15px;
}

.desc-box:hover{
  border: 1px solid #6467f0;
  outline: none;
}

.search-button{
  border-radius:0px 30px 30px 0px;
  margin-left:0px;
  font-size:15px;
  height:60px;
  padding: 12px 20px;
  background-color: #6467F0;
  color: white;
}

.input-box:hover{
  border: 1px solid #6467f0;
  outline: none;
}

.el-icon:hover{
  color: #6467F0;
}
</style>
